import { css, SerializedStyles } from '@emotion/react';

export const STATIC_STYLES: SerializedStyles = css`
    width: 100%;
    vertical-align: middle;
    position: relative;
    z-index: 99;
    border: none;
    overflow: hidden;
`;
